module.exports = __webpack_public_path__ + "static/media/bb.1d35c9c4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bb.svg
// module id = 2042
// module chunks = 0